import { render, staticRenderFns } from "./Scraper.vue?vue&type=template&id=666440e2&scoped=true"
import script from "./Scraper.vue?vue&type=script&lang=js"
export * from "./Scraper.vue?vue&type=script&lang=js"
import style0 from "./Scraper.vue?vue&type=style&index=0&id=666440e2&prod&scoped=true&lang=css"
import style1 from "./Scraper.vue?vue&type=style&index=1&id=666440e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666440e2",
  null
  
)

export default component.exports